import React from 'react';

import withPage from '../page';
import MDP from './components';

export default withPage(MDP, { wrapperClassName: 'mdp-root', showWordCloud: true, useV2: true, useGraphQL: true });
